import { createApiClient } from '@naia-app/trpc-client';
import { QueryClient } from '@tanstack/react-query';
import type { AppRouter } from 'api';

import { getAccessToken } from './session';
import { getActiveSchoolId } from './active-school';

/* Typed tRPC client + TanStack Query client for the backend (apps/api at */
/* backend.naia-edu.app). Auth token comes from the backend-issued session */
/* (lib/session) — no supabase-js in the web anymore. */

import { BACKEND_URL } from './config';

export const api = createApiClient<AppRouter>({
  url: `${BACKEND_URL}/trpc`,
  getAccessToken: () => getAccessToken(),
  getActiveSchoolId: () => getActiveSchoolId(),
});

export const queryClient = new QueryClient();
